import React from 'react';
import { Field } from 'react-form';
import PropTypes from 'prop-types';

import InfoButton from '../../InfoButton';
import SwitchButton from './SwitchButton';

import styles from './toggleSwitch.scss';

const ToggleSwitch = (props) => {
    return (
        <Field field={props.field} validate={props.validate}>
            {fieldApi => {
                const { onChange, onBlur, id, label, hiddenLabel, description, customLabel, formGroupCssClass, hoverText, disabled, disableLabelSelect, onClick, reverse, isEventEditForm, dontSetValueOnToggle, 'data-testid': dataTestId, ...rest } = props;
                const { value, error, warning, touched, setValue } = fieldApi;
                const inputProps = {
                    ...rest,
                    id,
                    checked: (reverse ? !value : value || false),
                    disabled,
                    onChange: e => {
                        const boolean = reverse ? !e.target.checked : e.target.checked;
                        if (!dontSetValueOnToggle) {
                            setValue(boolean);
                        }
                        if (onChange) {
                            onChange(boolean, e);
                        }
                    },
                };

                return (
                    <div
                        className={`form-group ${(touched && error) && 'is-invalid'} ${description && 'description'} ${styles.toggleSwitch} ${formGroupCssClass}`}
                        data-testid={dataTestId || undefined}
                    >
                        {!props.isSportTypeToggleSwitch && (
                            <>
                                <label htmlFor={id} className={`${!!hiddenLabel && 'sr-only'} ${!!isEventEditForm && 'pr80'}`}>
                                    {label}
                                    {hoverText && <InfoButton hoverText={hoverText} />}
                                </label>
                                {description && (<small>{description}</small>)}
                            </>

                        )}
                        <div className="input-wrapper">
                            <SwitchButton {...inputProps} isSportTypeToggleSwitch={props.isSportTypeToggleSwitch} data-testid={dataTestId && `${dataTestId}.toggle`} />
                        </div>
                        {touched &&
                            ((error && <div className="invalid-feedback" data-testid={dataTestId && `${dataTestId}.error`}>{error}</div>) ||
                            (warning && <div className="warning-feedback" data-testid={dataTestId && `${dataTestId}.warning`}>{warning}</div>))}
                    </div>
                );
            }}
        </Field>
    );
};

export const ControlledToggleSwitch = ({
    disabled,
    checked,
    hiddenLabel,
    id,
    onChange,
    label,
    hoverText,
    description,
    formGroupCssClass,
    'data-testid': dataTestId,
}) => {
    const handleChange = () => {
        if (onChange) {
            onChange(id);
        }
    };

    return (
        <div
            className={`form-group ${description && 'description'} ${styles.toggleSwitch} ${formGroupCssClass}`}
            data-testid={dataTestId || undefined}
        >
            <label htmlFor={id} className={`${hiddenLabel ? 'sr-only' : ''}`}>
                {label}
                {hoverText && <InfoButton hoverText={hoverText} />}
            </label>
            {description && (<small>{description}</small>)}
            <div className="input-wrapper">
                <SwitchButton
                    onChange={handleChange}
                    checked={checked}
                    id={id}
                    name={id}
                    disabled={disabled}
                    data-testid={dataTestId && `${dataTestId}.toggle`}
                />
            </div>
        </div>
    );
};

ToggleSwitch.propTypes = {
    isEventEditForm: PropTypes.bool,
    dontSetValueOnToggle: PropTypes.bool,
};
ToggleSwitch.defaultProps = {
    isEventEditForm: false,
    dontSetValueOnToggle: false,
};

export default ToggleSwitch;
